import React from 'react';
import Meta from "../../../components/common/Meta";
import MainDesign from "../../MainDesign";
import Presentation from "../../../components/user/parents/Presentation";

export default function PresentationPage() {
    return <>
        <Meta
            title='Przedstawienie Kursu | Produkacja'
            description='Zobacz, jak sposób wygląda Kurs od środka.'
        />
        <MainDesign containerStyles='container py-20' removeSectionOverflowHidden={true}>
            <Presentation/>
        </MainDesign>
    </>
}
